import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { annoncesAPI, commandesAPI, isLoggedIn } from '../api';
import '../App.css';

function ProductPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeThumb, setActiveThumb] = useState(0);
  const [zone, setZone] = useState('ville');
  const [delai, setDelai] = useState('express');
  const [qty, setQty] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [selectedMM, setSelectedMM] = useState('Wave');
  const [phone, setPhone] = useState('');
  const [cmdRef, setCmdRef] = useState('');
  const [cmdLoading, setCmdLoading] = useState(false);
  const [cmdError, setCmdError] = useState('');

  const zones = {
    ville: { urgent: 2000, express: 1500, normal: 1000 },
    region: { urgent: 3500, express: 2500, normal: 1500 },
    national: { urgent: 6000, express: 4500, normal: 3000 },
  };

  const mobileMoney = [
    { name: 'Wave', color: '#1AA3E8' },
    { name: 'Orange Money', color: '#FF6600' },
    { name: 'Free Money', color: '#CC0000' },
    { name: 'Expresso', color: '#8B0000' },
  ];

  const delaiNames = { urgent: 'Urgent 2h', express: 'Express 4h', normal: 'Normal 8h' };
  const thumbs = ['🔧', '⚙️', '🔩', '🛠️'];

  useEffect(() => {
    fetchProduct();
  }, [id]);

  const fetchProduct = async () => {
    setLoading(true);
    try {
      const res = await annoncesAPI.getOne(id);
      setProduct(res.data);
    } catch (err) {
      console.error('Erreur chargement produit:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return (
    <div className="app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', color: '#fff' }}>CHARGEMENT...</div>
      </div>
    </div>
  );

  if (!product) return (
    <div className="app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', color: '#fff', marginBottom: '8px' }}>ANNONCE INTROUVABLE</div>
        <Link to="/catalogue"><button className="btn-orange">Retour au catalogue</button></Link>
      </div>
    </div>
  );

  const frais = zones[zone][delai];
  const total = product.prix * qty + frais;

  const handleConfirm = async () => {
    if (!isLoggedIn()) { navigate('/connexion'); return; }
    if (phone.length < 9) { setCmdError('Veuillez entrer un numero valide'); return; }
    setCmdLoading(true);
    setCmdError('');
    try {
      const res = await commandesAPI.create({
        annonce_id: product.id,
        zone,
        delai,
        frais_livraison: frais,
        quantite: qty,
        mobile_money: selectedMM,
        adresse_livraison: phone,
      });
      setCmdRef(res.data.reference);
      setShowModal(false);
      setShowSuccess(true);
    } catch (err) {
      setCmdError(err.response?.data?.message || 'Erreur lors de la commande');
    } finally {
      setCmdLoading(false);
    }
  };

  const photos = product.photos ? (typeof product.photos === 'string' ? JSON.parse(product.photos) : product.photos) : [];
  const compat = product.compatibilite ? (typeof product.compatibilite === 'string' ? JSON.parse(product.compatibilite) : product.compatibilite) : [];

  return (
    <div className="app">
      {/* NAV */}
      <nav className="nav">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <div className="logo-wrap">
            <div className="logo">Tek<span>Teck</span></div>
            <div className="logo-tag">rak tak!</div>
          </div>
        </Link>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#888' }}>
          <Link to="/" style={{ color: '#F5620A', fontWeight: '600', textDecoration: 'none' }}>Accueil</Link>
          <span>›</span>
          <Link to="/catalogue" style={{ color: '#F5620A', fontWeight: '600', textDecoration: 'none' }}>Catalogue</Link>
          <span>›</span>
          <span>{product.nom_piece}</span>
        </div>
        <div className="nav-actions">
          <Link to="/connexion"><button className="btn-ghost">Se connecter</button></Link>
          <Link to="/deposer-annonce"><button className="btn-orange">Vendre mes pieces</button></Link>
        </div>
      </nav>

      {/* HEADER AD */}
      <div style={{ padding: '8px 32px', background: '#141414', borderBottom: '1px solid #2A2A2A' }}>
        <div className="ad-banner-slot">
          <span className="ad-tag">PUB · HEADER</span>
          <span className="ad-price-tag">25 000 F/sem · 90 000 F/mois</span>
          <div className="ad-content">
            <div className="ad-logo">🔋</div>
            <div className="ad-body">
              <div className="ad-sponsor">EXIDE BATTERIES</div>
              <div className="ad-title">Batteries Exide — Demarrage garanti · 2 ans de garantie · Livraison gratuite a Dakar</div>
            </div>
            <button className="ad-cta">Commander</button>
          </div>
        </div>
      </div>

      {/* PAGE BODY */}
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '24px 32px 80px', display: 'grid', gridTemplateColumns: '1fr 370px', gap: '24px', alignItems: 'start' }}>

        {/* COLONNE GAUCHE */}
        <div>
          {/* GALERIE */}
          <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '14px', overflow: 'hidden', marginBottom: '18px' }}>
            <div style={{ height: '320px', background: '#141414', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', borderBottom: '1px solid #2A2A2A' }}>
              {photos.length > 0 && activeThumb < photos.length ? (
                <img src={photos[activeThumb]} alt={product.nom_piece} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <span style={{ fontSize: '96px' }}>{thumbs[activeThumb % thumbs.length]}</span>
              )}
              <div style={{ position: 'absolute', top: '12px', left: '12px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <span style={{ background: 'rgba(34,197,94,.15)', color: '#22C55E', fontSize: '10px', fontWeight: '800', padding: '3px 10px', borderRadius: '5px' }}>{product.etat?.toUpperCase()}</span>
                <span style={{ background: 'rgba(245,98,10,.15)', color: '#F5620A', fontSize: '10px', fontWeight: '800', padding: '3px 10px', borderRadius: '5px' }}>{product.type_piece?.toUpperCase()}</span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px', padding: '10px' }}>
              {(photos.length > 0 ? photos : thumbs).map((t, i) => (
                <div key={i} onClick={() => setActiveThumb(i)} style={{ width: '64px', height: '64px', borderRadius: '7px', border: `2px solid ${activeThumb === i ? '#F5620A' : '#333'}`, background: '#141414', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', overflow: 'hidden' }}>
                  {photos.length > 0 ? <img src={t} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : t}
                </div>
              ))}
            </div>
          </div>

          {/* INFOS */}
          <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '14px', padding: '22px', marginBottom: '18px' }}>
            <div style={{ fontSize: '10px', fontWeight: '700', color: '#F5620A', letterSpacing: '.5px', marginBottom: '5px' }}>{product.type_vehicule?.toUpperCase()} · {product.categorie?.toUpperCase()}</div>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '30px', letterSpacing: '1px', color: '#fff', marginBottom: '6px', lineHeight: '1.1' }}>{product.nom_piece}</div>
            <div style={{ fontSize: '11px', color: '#888', marginBottom: '12px' }}>
              Ref. OEM : <span style={{ fontWeight: '700', color: '#fff' }}>{product.reference || 'N/A'}</span>
            </div>
            <div style={{ display: 'flex', gap: '7px', flexWrap: 'wrap', marginBottom: '16px' }}>
              <span style={{ background: 'rgba(34,197,94,.12)', color: '#22C55E', fontSize: '11px', fontWeight: '700', padding: '4px 11px', borderRadius: '20px' }}>✓ {product.etat}</span>
              <span style={{ background: 'rgba(245,98,10,.1)', color: '#F5620A', fontSize: '11px', fontWeight: '700', padding: '4px 11px', borderRadius: '20px' }}>{product.type_piece}</span>
              <span style={{ background: 'rgba(255,255,255,.07)', color: '#888', fontSize: '11px', fontWeight: '700', padding: '4px 11px', borderRadius: '20px' }}>Marque : {product.marque_vehicule}</span>
              <span style={{ background: 'rgba(255,255,255,.07)', color: '#888', fontSize: '11px', fontWeight: '700', padding: '4px 11px', borderRadius: '20px' }}>Annee : {product.annee_vehicule}</span>
              {product.garantie === 1 && <span style={{ background: 'rgba(34,197,94,.12)', color: '#22C55E', fontSize: '11px', fontWeight: '700', padding: '4px 11px', borderRadius: '20px' }}>✓ Garantie {product.garantie_duree}</span>}
            </div>
            {product.description && (
              <div style={{ fontSize: '13px', color: '#888', lineHeight: '1.6', borderTop: '1px solid #2A2A2A', paddingTop: '14px' }}>
                {product.description}
              </div>
            )}
            <div style={{ borderTop: '1px solid #2A2A2A', paddingTop: '14px', marginTop: '14px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
              {[
                { lbl: 'MARQUE VEHICULE', val: product.marque_vehicule },
                { lbl: 'ANNEE VEHICULE', val: product.annee_vehicule },
                { lbl: 'TYPE DE PIECE', val: product.type_piece },
                { lbl: 'ETAT', val: product.etat, green: true },
                { lbl: 'GARANTIE', val: product.garantie === 1 ? product.garantie_duree : 'Aucune' },
                { lbl: 'VILLE', val: '📍 ' + (product.vendeur_ville || 'N/A') },
              ].map((s, i) => (
                <div key={i} style={{ background: '#141414', borderRadius: '8px', padding: '9px 12px' }}>
                  <div style={{ fontSize: '9px', fontWeight: '700', color: '#888', letterSpacing: '.4px', marginBottom: '2px' }}>{s.lbl}</div>
                  <div style={{ fontSize: '13px', fontWeight: '700', color: s.green ? '#22C55E' : '#fff' }}>{s.val}</div>
                </div>
              ))}
            </div>
          </div>

          {/* AD INLINE */}
          <div className="ad-banner-slot" style={{ marginBottom: '18px' }}>
            <span className="ad-tag">PUB · INLINE</span>
            <span className="ad-price-tag">12 000 F/sem · 42 000 F/mois</span>
            <div className="ad-content">
              <div className="ad-logo">🛠️</div>
              <div className="ad-body">
                <div className="ad-sponsor">ATELIER PRO DAKAR</div>
                <div className="ad-title">Pose de votre piece a domicile — Mecaniciens certifies · Devis gratuit</div>
              </div>
              <button className="ad-cta">Reserver</button>
            </div>
          </div>

          {/* COMPATIBILITE */}
          {compat.length > 0 && (
            <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '14px', padding: '20px 22px', marginBottom: '18px' }}>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '18px', letterSpacing: '1px', color: '#fff', marginBottom: '12px' }}>🔗 COMPATIBILITE VEHICULE</div>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {['Modele', 'Annee debut', 'Annee fin'].map(h => (
                      <th key={h} style={{ textAlign: 'left', padding: '7px 10px', fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.4px', borderBottom: '1px solid #2A2A2A' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {compat.map((c, i) => (
                    <tr key={i} style={{ borderBottom: i < compat.length - 1 ? '1px solid #2A2A2A' : 'none' }}>
                      <td style={{ padding: '9px 10px', fontSize: '12px', color: '#fff', fontWeight: '500' }}>{c.modele}</td>
                      <td style={{ padding: '9px 10px', fontSize: '12px', color: '#888' }}>{c.debut || '—'}</td>
                      <td style={{ padding: '9px 10px', fontSize: '12px', color: '#888' }}>{c.fin || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* COLONNE DROITE */}
        <div style={{ position: 'sticky', top: '72px' }}>
          {/* ORDER CARD */}
          <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '14px', padding: '22px', marginBottom: '14px', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, #F5620A, #FF7A2E, transparent)' }}></div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '3px' }}>
              <span style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '36px', letterSpacing: '1px', color: '#F5620A' }}>{(product.prix * qty).toLocaleString('fr-FR')}</span>
              <span style={{ fontSize: '14px', fontWeight: '700', color: '#888' }}>FCFA</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '12px', fontWeight: '700', color: '#22C55E', marginBottom: '16px' }}>
              <div style={{ width: '8px', height: '8px', background: '#22C55E', borderRadius: '50%' }}></div>
              En stock · {product.quantite} disponible{product.quantite > 1 ? 's' : ''}
            </div>

            {/* QTY */}
            <div style={{ fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.4px', marginBottom: '6px' }}>QUANTITE</div>
            <div style={{ display: 'flex', alignItems: 'center', border: '1.5px solid #333', borderRadius: '9px', overflow: 'hidden', width: 'fit-content', marginBottom: '16px' }}>
              <button onClick={() => setQty(Math.max(1, qty - 1))} style={{ width: '36px', height: '36px', border: 'none', background: '#141414', color: '#fff', fontSize: '18px', cursor: 'pointer', fontWeight: '700' }}>−</button>
              <span style={{ width: '44px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', fontWeight: '800', color: '#fff', borderLeft: '1px solid #333', borderRight: '1px solid #333' }}>{qty}</span>
              <button onClick={() => setQty(Math.min(product.quantite, qty + 1))} style={{ width: '36px', height: '36px', border: 'none', background: '#141414', color: '#fff', fontSize: '18px', cursor: 'pointer', fontWeight: '700' }}>+</button>
            </div>

            {/* ZONE */}
            <div style={{ fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.4px', marginBottom: '8px' }}>ZONE DE LIVRAISON</div>
            <div style={{ display: 'flex', gap: '5px', marginBottom: '12px' }}>
              {[['ville', 'Meme ville'], ['region', 'Region'], ['national', 'National']].map(([key, label]) => (
                <button key={key} onClick={() => setZone(key)} style={{ flex: '1', padding: '7px 8px', border: `1.5px solid ${zone === key ? '#F5620A' : '#333'}`, borderRadius: '7px', fontSize: '11px', fontWeight: '700', cursor: 'pointer', background: zone === key ? '#F5620A' : '#141414', color: '#fff', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  {label}
                </button>
              ))}
            </div>

            {/* DELAIS */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '7px', marginBottom: '14px' }}>
              {[
                { key: 'urgent', icon: '⚡', label: 'Urgent — 2h', desc: 'Collecte & livraison en 2h' },
                { key: 'express', icon: '🚀', label: 'Express — 4h', desc: 'Livraison dans la journee' },
                { key: 'normal', icon: '📦', label: 'Normal — 8h', desc: 'Planifie, economique' },
              ].map(d => (
                <div key={d.key} onClick={() => setDelai(d.key)} style={{ border: `1.5px solid ${delai === d.key ? '#F5620A' : '#333'}`, borderRadius: '9px', padding: '11px 13px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: delai === d.key ? 'rgba(245,98,10,.1)' : '#141414' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
                    <span style={{ fontSize: '18px' }}>{d.icon}</span>
                    <div>
                      <div style={{ fontSize: '13px', fontWeight: '800', color: delai === d.key ? '#F5620A' : '#fff' }}>{d.label}</div>
                      <div style={{ fontSize: '10px', color: '#888' }}>{d.desc}</div>
                    </div>
                  </div>
                  <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '16px', letterSpacing: '.5px', color: delai === d.key ? '#F5620A' : '#fff' }}>{zones[zone][d.key].toLocaleString('fr-FR')} F</div>
                </div>
              ))}
            </div>

            {/* TOTAL */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderTop: '1px solid #2A2A2A', marginTop: '4px' }}>
              <div>
                <div style={{ fontSize: '12px', color: '#888', fontWeight: '600' }}>Piece + livraison</div>
              </div>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '22px', letterSpacing: '1px', color: '#fff' }}>{total.toLocaleString('fr-FR')} FCFA</div>
            </div>

            <button onClick={() => setShowModal(true)} style={{ width: '100%', padding: '14px', background: '#F5620A', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '800', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif', marginBottom: '8px' }}>
              Commander & payer →
            </button>
            <button style={{ width: '100%', padding: '10px', background: 'transparent', border: '1.5px solid #333', borderRadius: '10px', fontSize: '13px', fontWeight: '700', color: '#888', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              ♡ Ajouter aux favoris
            </button>
          </div>

          {/* MOBILE MONEY */}
          <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '14px', padding: '18px 20px', marginBottom: '14px' }}>
            <div style={{ fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.5px', marginBottom: '12px' }}>PAIEMENT ACCEPTE</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {mobileMoney.map(mm => (
                <div key={mm.name} style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '6px 12px', borderRadius: '7px', border: '1.5px solid #333', fontSize: '11px', fontWeight: '800', background: '#141414' }}>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: mm.color }}></div>
                  <span style={{ color: mm.color }}>{mm.name}</span>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', background: 'rgba(34,197,94,.08)', borderRadius: '8px', padding: '9px 12px', marginTop: '12px' }}>
              <span style={{ fontSize: '16px', flexShrink: 0 }}>🛡️</span>
              <div style={{ fontSize: '11px', color: '#22C55E', fontWeight: '600', lineHeight: '1.5' }}>Paiement securise TekTeck. Vos fonds sont conserves jusqu'a confirmation de reception.</div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer>
        <div className="footer-bottom" style={{ padding: '20px 32px' }}>
          <span>2025 TekTeck · tekteck.com</span>
          <span style={{ color: '#666' }}>Confidentialite · CGU · CGV</span>
        </div>
      </footer>

      {/* MODAL PAIEMENT */}
      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.8)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '16px', padding: '28px 30px', maxWidth: '420px', width: '92%', maxHeight: '88vh', overflowY: 'auto' }}>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', letterSpacing: '1px', color: '#fff', marginBottom: '4px' }}>CONFIRMER LA COMMANDE</div>
            <div style={{ fontSize: '12px', color: '#888', marginBottom: '18px' }}>Recapitulatif & paiement Mobile Money</div>

            {cmdError && (
              <div style={{ background: 'rgba(239,68,68,.12)', border: '1px solid rgba(239,68,68,.3)', borderRadius: '8px', padding: '10px 14px', marginBottom: '14px', fontSize: '12px', color: '#EF4444', fontWeight: '700' }}>
                ❌ {cmdError}
              </div>
            )}

            <div style={{ background: '#141414', borderRadius: '10px', padding: '14px', marginBottom: '16px' }}>
              {[
                { label: product.nom_piece + ' x' + qty, value: (product.prix * qty).toLocaleString('fr-FR') + ' FCFA' },
                { label: 'Livraison (' + delaiNames[delai] + ')', value: frais.toLocaleString('fr-FR') + ' FCFA' },
              ].map((r, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', padding: '4px 0', color: '#888' }}>
                  <span>{r.label}</span><span style={{ fontWeight: '700', color: '#fff' }}>{r.value}</span>
                </div>
              ))}
              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '800', borderTop: '1px solid #2A2A2A', marginTop: '8px', paddingTop: '10px', fontSize: '15px', color: '#fff' }}>
                <span>Total</span><span style={{ color: '#F5620A' }}>{total.toLocaleString('fr-FR')} FCFA</span>
              </div>
            </div>

            <div style={{ fontSize: '11px', fontWeight: '700', color: '#888', letterSpacing: '.4px', marginBottom: '10px' }}>MOYEN DE PAIEMENT</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '14px' }}>
              {mobileMoney.map(mm => (
                <div key={mm.name} onClick={() => setSelectedMM(mm.name)} style={{ padding: '11px', border: `1.5px solid ${selectedMM === mm.name ? '#F5620A' : '#333'}`, borderRadius: '9px', cursor: 'pointer', textAlign: 'center', background: selectedMM === mm.name ? 'rgba(245,98,10,.1)' : '#141414' }}>
                  <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: mm.color, margin: '0 auto 5px' }}></div>
                  <div style={{ fontSize: '11px', fontWeight: '800', color: mm.color }}>{mm.name}</div>
                </div>
              ))}
            </div>

            <div style={{ fontSize: '11px', fontWeight: '700', color: '#888', letterSpacing: '.4px', marginBottom: '8px' }}>NUMERO MOBILE MONEY</div>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
              <div style={{ padding: '10px 12px', background: '#141414', border: '1.5px solid #333', borderRadius: '9px', fontSize: '14px', fontWeight: '700', color: '#fff' }}>🇸🇳 +221</div>
              <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="7X XXX XX XX" maxLength="9" style={{ flex: '1', padding: '10px 14px', background: '#141414', border: '1.5px solid #333', borderRadius: '9px', fontSize: '14px', fontFamily: 'Plus Jakarta Sans, sans-serif', color: '#fff', outline: 'none' }} />
            </div>

            <button onClick={handleConfirm} disabled={cmdLoading} style={{ width: '100%', padding: '13px', background: cmdLoading ? '#333' : '#F5620A', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '800', color: '#fff', cursor: cmdLoading ? 'not-allowed' : 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif', marginBottom: '8px' }}>
              {cmdLoading ? '⏳ Traitement...' : 'Confirmer & payer'}
            </button>
            <button onClick={() => setShowModal(false)} style={{ width: '100%', padding: '10px', background: 'transparent', border: '1.5px solid #333', borderRadius: '10px', fontSize: '13px', fontWeight: '700', color: '#888', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {/* SUCCESS */}
      {showSuccess && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.85)', zIndex: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#1C1C1C', border: '1px solid #F5620A', borderRadius: '16px', padding: '36px 30px', maxWidth: '380px', width: '92%', textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '14px' }}>✅</div>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '28px', letterSpacing: '1.5px', color: '#F5620A', marginBottom: '8px' }}>RAK TAK !</div>
            <div style={{ display: 'inline-block', background: 'rgba(245,98,10,.1)', color: '#F5620A', fontSize: '12px', fontWeight: '800', padding: '5px 16px', borderRadius: '20px', marginBottom: '14px', border: '1px solid rgba(245,98,10,.3)' }}>{cmdRef}</div>
            <div style={{ fontSize: '12px', color: '#888', lineHeight: '1.7', marginBottom: '22px' }}>Commande confirmee ! TekTeck collecte votre piece et vous la livre dans le delai choisi.</div>
            <Link to="/mon-compte">
              <button style={{ width: '100%', padding: '13px', background: '#F5620A', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '800', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                Voir mes commandes
              </button>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductPage;